<template>
  <main class="works">
    <div id="gallery" class="gallery">
      <ul>
        <li id="graphic"><div class="box"><span class="category">graphic</span></div></li>
        <li v-for="(item, index) in items.graphic" :key="'graphic'+index"><a href="" v-on:click.prevent="popup(0,index)"><img v-bind:src="item.thumb" v-on:load="countLoad" alt=""></a><p class="caption">{{ item.caption }}</p></li>

        <li id="editorial"><div class="box"><span class="category">editorial</span></div></li>
        <li v-for="(item, index) in items.editorial" :key="'editorial'+index"><a href="" v-on:click.prevent="popup(1,index)"><img v-bind:src="item.thumb" v-on:load="countLoad" alt=""></a><p class="caption">{{ item.caption }}</p></li>

        <li id="package"><div class="box"><span class="category">package</span></div></li>
        <li v-for="(item, index) in items.package" :key="'package'+index"><a href="" v-on:click.prevent="popup(2,index)"><img v-bind:src="item.thumb" v-on:load="countLoad" alt=""></a><p class="caption">{{ item.caption }}</p></li>

        <li id="logo_ci_vi"><div class="box"><span class="category">logo,CI,VI</span></div></li>
        <li v-for="(item, index) in items.logo_ci_vi" :key="'logo_ci_vi'+index"><a href="" v-on:click.prevent="popup(3,index)"><img v-bind:src="item.thumb" v-on:load="countLoad" alt=""></a><p class="caption">{{ item.caption }}</p></li>

        <li id="character"><div class="box"><span class="category">character</span></div></li>
        <li v-for="(item, index) in items.character" :key="'character'+index"><a href="" v-on:click.prevent="popup(4,index)"><img v-bind:src="item.thumb" v-on:load="countLoad" alt=""></a><p class="caption">{{ item.caption }}</p></li>

        <li id="web"><div class="box"><span class="category">web</span></div></li>
        <li v-for="(item, index) in items.web" :key="'web'+index"><a href="" v-on:click.prevent="popup(5,index)"><img v-bind:src="item.thumb" v-on:load="countLoad" alt=""></a><p class="caption">{{ item.caption }}</p></li>
      </ul>
    </div>

    <div id="modal" class="popup">
      <div class="gallery_wrap">
        <picture v-if="gallery.length > 0">
          <source media="(min-width: 768px)" v-bind:srcset="gallery[target[0]][target[1]]+' 1x, '+changeDouble(gallery[target[0]][target[1]])+' 2x'">
          <img id="gallery_img" v-bind:src="gallery[target[0]][target[1]]" alt="">
        </picture>
      </div>
      <p class="caption"></p>
      <button id="prev" v-on:click="galPrev" v-if="target[0]>0||target[0]==0&&target[1]>0"></button>
      <template v-if="gallery.length>0">
        <button id="next" v-on:click="galNext" v-if="target[0]<gallery.length-1||(target[0]==gallery.length-1&&target[1]<gallery[target[0]].length-1)"></button>
      </template>
      <button id="close" v-on:click="galClose"></button>
    </div>
  </main>
</template>

<style lang="scss" src="@/assets/scss/works.scss" scoped></style>

<script>
import axios from 'axios'
import ObjFitImg from 'object-fit-images'
export default {
  data() {
    return {
      items: [],
      gallery: [],
      typeArr: ['graphic','editorial','package','logo_ci_vi','character','web'],
      openType: 0,
      target: [0, 0],
      count: 0,
      window: {
        w: window.innerWidth,
        h: window.innerHeight
      }
    }
  },
  created() {
    var self = this
    axios.get('/data/works.json')
      .then(response => {
        self.items = response.data
        self.thumbSet()
        self.gallerySet()
      })
      .catch(() => {
        console.log('error')
      })
  },
  mounted() {
    var modal = document.getElementById('modal')
    if (this.isMobile()) {
      modal.style.height = this.window.h+'px'
    }
  },
  watch: {
    target: function() {
      setTimeout(function() {
        ObjFitImg('#gallery_img')
      }, 100)
    }
  },
  methods: {
    isMobile: function(){
      var regexp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      return (window.navigator.userAgent.search(regexp) !== -1);
    },
    zeroPad: function(num, padsize) {
      if (padsize == 2) {
        return ('00' + num).slice(-3)
      } else if (padsize == 1) {
        return ('0' + num).slice(-2)
      }
    },
    thumbSet: function() {
      var self = this
      self.typeArr.forEach(function(type) {
        self.items[type].forEach(function(val, index) {
          val['thumb'] = '/img/works/'+type+'/'+self.zeroPad(index+1, 2)+'/thumb.jpg'
        })
      })
    },
    countLoad: function() {
      var gallery = document.getElementById('gallery')
      var hash = location.hash
      this.count++
      if (this.count == this.items.graphic.length + this.items.editorial.length + this.items.package.length + this.items.logo_ci_vi.length + this.items.character.length + this.items.web.length) {
        if (hash) {
          var target = document.getElementById(hash.replace('#',''))
          scrollTo(0, target.offsetTop)
        }
        gallery.classList.add('show')
      }
    },
    gallerySet: function() {
      var self = this
      self.typeArr.forEach(function(type) {
        self.items[type].forEach(function(val, index) {
          if (val.gallery) {
            var gal_arr = []
            for (var i=0; i<val.gallery; i++) {
              gal_arr.push('/img/works/'+type+'/'+self.zeroPad(index+1, 2)+'/img'+self.zeroPad(i+1, 1)+'.jpg')
            }
            self.gallery.push(gal_arr)
          }
        })
      })
    },
    changeDouble: function(src) {
      return src.replace('.jpg', '@2x.jpg')
    },
    popup: function(type, num) {
      var modal = document.getElementById('modal')

      this.openType = type
      for (var i=0; i<type; i++) {
        num += this.items[this.typeArr[i]].length
      }
      this.target = [num, 0]

      modal.classList.remove('hide')
      modal.classList.add('show')
    },
    galNext: function() {
      if (this.target[1] + 1 < this.gallery[this.target[0]].length) {
        this.$set(this.target, 1, this.target[1]+1)
      } else {
        this.$set(this.target, 0, this.target[0]+1)
        this.$set(this.target, 1, 0)
      }
    },
    galPrev: function() {
      if (this.target[1] > 0) {
        this.$set(this.target, 1, this.target[1]-1)
      } else {
        this.$set(this.target, 0, this.target[0]-1)
        this.$set(this.target, 1, this.gallery[this.target[0]].length-1)
      }
    },
    galClose: function() {
      var modal = document.getElementById('modal')
      modal.classList.add('hide')
      setTimeout(function() {
        modal.classList.remove('show','hide')
      }, 500)
    }
  }
}
</script>
